/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ListValueDTO } from './ListValueDTO';
import type { MetadataDTO } from './MetadataDTO';
import type { SelectOptionDTO } from './SelectOptionDTO';
import type { VariableDTO } from './VariableDTO';

export type MultiSelectInputVariableDTO = (VariableDTO & {
    name?: string;
    description?: string;
    metadata?: Array<MetadataDTO>;
    sequence?: number;
    section?: MultiSelectInputVariableDTO.section;
    hasUiContract?: boolean;
    alwaysActive?: boolean;
    visibility?: MultiSelectInputVariableDTO.visibility;
    value?: ListValueDTO;
    defaultValue?: ListValueDTO;
    options?: Array<SelectOptionDTO>;
});

export namespace MultiSelectInputVariableDTO {

    export enum section {
        GEOMETRY_SECTION = 'GEOMETRY_SECTION',
        COMPONENT_SECTION = 'COMPONENT_SECTION',
        SURFACE_SECTION = 'SURFACE_SECTION',
        CALCULATION_SECTION = 'CALCULATION_SECTION',
        ADDITIONAL_WORK_SECTION = 'ADDITIONAL_WORK_SECTION',
        QUALITY_SECTION = 'QUALITY_SECTION',
    }

    export enum visibility {
        HIDDEN = 'HIDDEN',
        DISABLED = 'DISABLED',
        VISIBLE = 'VISIBLE',
    }


}
